var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0",attrs:{"id":"last-3hours-summary-page"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('OnAir'),_c('OffAir'),_c('Major'),_c('AllDonations')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }